import { TemporalityStatusType } from "../components/KeydriveComponents/KeydriveDeadline";

export function getFutureDateString(temporalityDate: Date | null, days: number | undefined): string {
    if (days == 0 || days == undefined) return new Date(temporalityDate!).toDateString();

    const currentDate = new Date(temporalityDate!);
    let daysLater = new Date(currentDate);
    daysLater.setDate(currentDate.getDate() - days);

    return daysLater.toDateString();
}

export function getDueDateStatus(dueDate: Date): TemporalityStatusType {
  const today = new Date();
  const normalize = (date: Date) =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate());

  const current = normalize(today);
  const due = normalize(dueDate);

  const diffInMs = due.getTime() - current.getTime();
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

  if (diffInDays < 0) return "expired";
  if (diffInDays <= 5) return "near";
  return "ok";
}